import { useAuth } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

import { TancisPortalMainChart } from "./TancisPortalMainChart";
import { TancisPortalMainTab } from "./TancisPortalMainTab";
import { TancisPortalMainNotification } from "./TancisPortalMainNotification";

const TancisPortalMain = () => {
    const auth = useAuth();

    if (comnUtils.isEmpty(auth.get("usrId"))) {
        return null;
    }

    return (
        <div className="flex flex-col gap-4 [&_h2]:font-semibold">
            <div className="flex">
                <TancisPortalMainChart />
            </div>
            <div className="flex flex-1 gap-4 flex-col lg:flex-row">
                <div className="flex-1 h-full">
                    <TancisPortalMainTab />
                </div>
                <div className="flex-1 h-full">
                    <TancisPortalMainNotification />
                </div>
            </div>
        </div>
    );
};

export default TancisPortalMain;
